import ajax from 'api/ajax'
// 购置情况
class useCondition {
    // 购置情况列表tab
    getUselist = ( per_page, page ,key) => ajax('order/search',{'per-page':per_page, page ,key}, 'get')
    // 购置信息列表
    getUseMessageList= ( per_page, page ,orderno) => ajax('chem-storage/search',{'per-page':per_page, page ,orderno}, 'get')

    // 使用情况列表tab
    getEmploylist = ( per_page, page ,key) => ajax('userstorage/search',{'per-page':per_page, page ,key}, 'get')
    // 我的使用情况列表
    getMyUserList= ( per_page, page ,chemid,userid) => ajax('chem-storage/search',{'per-page':per_page, page ,chemid,userid}, 'get')


}

export default useCondition
